import React from "react";

const LandingStats: React.FC = () => {
    return (
        <>
            <div className=" py-8 md:py-16 bg-[#317333] w-full px-4 md:px-14 flex flex-col md:flex-row space-y-6 md:space-y-0 items-center">
                <div className=" w-[80%] md:w-1/3 flex flex-col items-center justify-center">
                    <span className=" text-white font-Manrope font-extrabold text-[32px] text-center">
                        1300 hrs
                    </span>
                    <p className=" font-Manrope font-normal text-base text-white text-center">
                        SACA minute played
                    </p>
                </div>
                <div className=" w-[80%] md:w-1/3 flex flex-col items-center justify-center border-y py-6 md:py-0 md:border-y-0 md:border-x border-[#fff]">
                    <span className=" text-white font-Manrope font-extrabold text-[32px] text-left">
                        200
                    </span>
                    <p className=" font-Manrope font-normal text-center text-base text-white">
                        SACA session completed
                    </p>
                </div>
                <div className=" w-[80%] md:w-1/3 flex flex-col items-center justify-center">
                    <span className=" text-white font-Manrope font-extrabold text-[32px] text-center">
                        1
                    </span>
                    <p className=" font-Manrope font-normal text-base text-center text-white">
                        Location worldwide
                    </p>
                </div>
            </div>
        </>
    );
};

export default LandingStats;
